import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopMetaFragmentDoc } from './shop-meta.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopTaxonItemAttributesFragment = { __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined };

export type ShopTaxonBadgeItemAttributesFragment = { __typename: 'ShopTaxonBadgeObject', id: number, name: string, badgeIconUrl?: string | null | undefined };

export type ShopTaxonDetailAttributesFragment = { __typename: 'ShopTaxonObject', id: number, path: string, locale: string, name: string, slug: string, description?: string | null | undefined, contentRef?: string | null | undefined, parentId?: number | null | undefined, position: number, badge: boolean, channelCode: string, productCount: number, descendentProductCount: number, hidden: boolean, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined }, children: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, ascendents: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, siblings: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, descendents: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }> };

export type ShopTaxonChildFragment = { __typename: 'ShopTaxonObject', id: number, hidden: boolean, descendentProductCount: number, productCount: number, position: number, name: string, slug: string, path: string, channelCode: string };

export type ShopTaxonDetailByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
  regionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopTaxonDetailByIdQuery = { __typename: 'Query', shopTaxon: { __typename: 'ShopTaxonObject', id: number, path: string, locale: string, name: string, slug: string, description?: string | null | undefined, contentRef?: string | null | undefined, parentId?: number | null | undefined, position: number, badge: boolean, channelCode: string, productCount: number, descendentProductCount: number, hidden: boolean, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined }, children: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, ascendents: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, siblings: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, descendents: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }> } };

export type ShopTaxonPathByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopTaxonPathByIdQuery = { __typename: 'Query', shopTaxon: { __typename: 'ShopTaxonObject', path: string } };

export type ShopTaxonContentRefByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopTaxonContentRefByIdQuery = { __typename: 'Query', shopTaxon: { __typename: 'ShopTaxonObject', contentRef?: string | null | undefined } };

export type ShopChannelRootTaxonDetailQueryVariables = Types.Exact<{
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
  regionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopChannelRootTaxonDetailQuery = { __typename: 'Query', shopChannelRootTaxon: { __typename: 'ShopTaxonObject', id: number, path: string, locale: string, name: string, slug: string, description?: string | null | undefined, contentRef?: string | null | undefined, parentId?: number | null | undefined, position: number, badge: boolean, channelCode: string, productCount: number, descendentProductCount: number, hidden: boolean, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined }, children: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, ascendents: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, siblings: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, descendents: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }> } };

export type ShopTaxonMetaByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopTaxonMetaByIdQuery = { __typename: 'Query', shopTaxon: { __typename: 'ShopTaxonObject', name: string, description?: string | null | undefined, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } } };

export type ShopTaxonStateQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopTaxonStateQuery = { __typename: 'Query', shopTaxon: { __typename: 'ShopTaxonObject', id: number, name: string, description?: string | null | undefined, slug: string, hidden: boolean, path: string, contentRef?: string | null | undefined, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } } };

export type ShopTaxonChildrenQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
  regionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopTaxonChildrenQuery = { __typename: 'Query', shopTaxon: { __typename: 'ShopTaxonObject', id: number, children: Array<{ __typename: 'ShopTaxonObject', id: number, hidden: boolean, descendentProductCount: number, productCount: number, position: number, name: string, slug: string, path: string, channelCode: string }> } };

export const ShopTaxonBadgeItemAttributesFragmentDoc = gql`
    fragment ShopTaxonBadgeItemAttributes on ShopTaxonBadgeObject {
  id
  name
  badgeIconUrl
}
    `;
export const ShopTaxonItemAttributesFragmentDoc = gql`
    fragment ShopTaxonItemAttributes on ShopTaxonObject {
  id
  parentId
  position
  name
  slug
  badge
  productCount
  descendentProductCount
  channelCode
  hidden
  path
  contentRef
}
    `;
export const ShopTaxonDetailAttributesFragmentDoc = gql`
    fragment ShopTaxonDetailAttributes on ShopTaxonObject {
  id
  path
  locale
  name
  slug
  description
  meta {
    ...ShopMeta
  }
  contentRef
  parentId
  position
  badge
  path
  channelCode
  children {
    ...ShopTaxonItemAttributes
  }
  ascendents {
    ...ShopTaxonItemAttributes
  }
  siblings {
    ...ShopTaxonItemAttributes
  }
  descendents {
    ...ShopTaxonItemAttributes
  }
  productCount
  descendentProductCount
  hidden
}
    ${ShopMetaFragmentDoc}
${ShopTaxonItemAttributesFragmentDoc}`;
export const ShopTaxonChildFragmentDoc = gql`
    fragment ShopTaxonChild on ShopTaxonObject {
  id
  hidden
  descendentProductCount
  productCount
  position
  name
  slug
  path
  channelCode
}
    `;
export const ShopTaxonDetailByIdDocument = gql`
    query ShopTaxonDetailById($id: Int!, $locale: String!, $channelCode: String!, $regionId: Int) {
  shopTaxon(
    id: $id
    locale: $locale
    channelCode: $channelCode
    regionId: $regionId
  ) {
    ...ShopTaxonDetailAttributes
  }
}
    ${ShopTaxonDetailAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopTaxonDetailByIdGQL extends Apollo.Query<ShopTaxonDetailByIdQuery, ShopTaxonDetailByIdQueryVariables> {
    document = ShopTaxonDetailByIdDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopTaxonPathByIdDocument = gql`
    query ShopTaxonPathById($id: Int!, $locale: String!, $channelCode: String!) {
  shopTaxon(id: $id, locale: $locale, channelCode: $channelCode) {
    path
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopTaxonPathByIdGQL extends Apollo.Query<ShopTaxonPathByIdQuery, ShopTaxonPathByIdQueryVariables> {
    document = ShopTaxonPathByIdDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopTaxonContentRefByIdDocument = gql`
    query ShopTaxonContentRefById($id: Int!, $locale: String!, $channelCode: String!) {
  shopTaxon(id: $id, locale: $locale, channelCode: $channelCode) {
    contentRef
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopTaxonContentRefByIdGQL extends Apollo.Query<ShopTaxonContentRefByIdQuery, ShopTaxonContentRefByIdQueryVariables> {
    document = ShopTaxonContentRefByIdDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopChannelRootTaxonDetailDocument = gql`
    query ShopChannelRootTaxonDetail($locale: String!, $channelCode: String!, $regionId: Int) {
  shopChannelRootTaxon(
    locale: $locale
    channelCode: $channelCode
    regionId: $regionId
  ) {
    ...ShopTaxonDetailAttributes
  }
}
    ${ShopTaxonDetailAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopChannelRootTaxonDetailGQL extends Apollo.Query<ShopChannelRootTaxonDetailQuery, ShopChannelRootTaxonDetailQueryVariables> {
    document = ShopChannelRootTaxonDetailDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopTaxonMetaByIdDocument = gql`
    query ShopTaxonMetaById($id: Int!, $locale: String!, $channelCode: String!) {
  shopTaxon(id: $id, locale: $locale, channelCode: $channelCode) {
    meta {
      description
      title
      keywords
    }
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopTaxonMetaByIdGQL extends Apollo.Query<ShopTaxonMetaByIdQuery, ShopTaxonMetaByIdQueryVariables> {
    document = ShopTaxonMetaByIdDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopTaxonStateDocument = gql`
    query ShopTaxonState($id: Int!, $locale: String!, $channelCode: String!) {
  shopTaxon(id: $id, locale: $locale, channelCode: $channelCode) {
    id
    name
    description
    slug
    hidden
    meta {
      ...ShopMeta
    }
    path
    contentRef
  }
}
    ${ShopMetaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopTaxonStateGQL extends Apollo.Query<ShopTaxonStateQuery, ShopTaxonStateQueryVariables> {
    document = ShopTaxonStateDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopTaxonChildrenDocument = gql`
    query ShopTaxonChildren($id: Int!, $locale: String!, $channelCode: String!, $regionId: Int) {
  shopTaxon(
    id: $id
    locale: $locale
    channelCode: $channelCode
    regionId: $regionId
  ) {
    id
    children {
      ...ShopTaxonChild
    }
  }
}
    ${ShopTaxonChildFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopTaxonChildrenGQL extends Apollo.Query<ShopTaxonChildrenQuery, ShopTaxonChildrenQueryVariables> {
    document = ShopTaxonChildrenDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }